import {useNavigate} from "react-router-dom";

import {SectionCardHeaderAction, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";
import EditIcon from "@mui/icons-material/Edit";
import {SisbagalSectionCard} from "sisbagal/auth";

const EDARTratamentoPretratamentoPrimarioSection = ({edar}) => {
    const navigate = useNavigate();

    const secondaryActions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                navigate(`pretratamentoprimario/edit`);
            }}
            roles={[]}
        />,
    ];

    return (
        <SisbagalSectionCard
            title="Pretratamento e primario"
            secondaryActions={secondaryActions}
        >
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Vertido directo:"
                        value={edar.vertido_directo_label}
                        tooltipText="Planta bypaseada ou un punto de vertido directo de ARU"
                    />
                    <SectionField
                        label="Pretratamento:"
                        value={edar.pretratamento_label}
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Número de liñas primario:"
                        value={edar.trat_primario_lineas}
                        tooltipText="Número de liñas de tratamento primario"
                    />
                    <SectionField
                        label="Tipo de tratamento:"
                        value={edar.trat_primario_label}
                        tooltipText="Tipoloxía de tratamento primario"
                    />
                    <SectionField
                        label="Outros tipos de tratamento:"
                        value={edar.trat_primario_outro}
                        tooltipText="Outro tratamento primario"
                    />
                </Grid>
            </Grid>
        </SisbagalSectionCard>
    );
};

export default EDARTratamentoPretratamentoPrimarioSection;
